<template>
  <div id="app">
    <router-view></router-view>
 
  </div>
</template>

<script>
import Home from './components/Home.vue'
import BakingIngredients from './components/BakingIngredients.vue'
import AboutUs from './components/AboutUs.vue'
import ContactUs from './components/ContactUs.vue'
import New from './components/New.vue'

export default {
  name: 'App',
  components: {
    Home,
    AboutUs,
    BakingIngredients,
    ContactUs,
    New
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
